/*
 * B2B price view: VAT handling per delivery country.
 *
 * Tax setup (since 08/2026): VAT is ONLY collected for deliveries to
 * Poland. For every other destination the checkout charges the sticker
 * price with no tax line — the sticker price IS the net price
 * ("exkl. MwSt.", reverse charge within the EU / export outside the EU).
 *
 * Two display models, driven by window.__b2bVatCharged (set in
 * layout/theme.liquid from localization.country):
 *
 *   1. VAT charged (Poland market): sticker prices include Polish VAT
 *      (window.__b2bVatRate, 23 %). The customer can switch the displayed
 *      prices between gross ("inkl. MwSt.", default) and an informational
 *      net view ("exkl. MwSt.", gross / 1.23, marked with *) — checkout
 *      always charges gross.
 *
 *   2. No VAT charged (everywhere else, default): prices are shown as-is
 *      and labeled "exkl. MwSt." — that is the final amount. No toggle,
 *      no asterisks, factor is always 1.
 *
 * Integration points:
 *   - prices-loader.js calls window.__vatScaleC(cents) inside its money
 *     formatters -> covers PDP, product cards and cart drawer line items.
 *   - Liquid-rendered amounts carry [data-vat-cents] (+ optional
 *     [data-vat-prefix]) and are re-formatted here. The attribute value is
 *     always the sticker price in cents.
 *   - [data-vat-reciprocal-cents] renders the explanatory sentence below
 *     the PDP price.
 *   - Toggle UIs (only rendered for Poland, see b2b-vat-toggle snippet)
 *     are marked with [data-vat-toggle-input].
 */
(function () {
  if (window.__b2bVatViewInit) return;
  window.__b2bVatViewInit = true;

  var RATE = (typeof window.__b2bVatRate === 'number' && isFinite(window.__b2bVatRate))
    ? window.__b2bVatRate : 23;
  var CHARGED = window.__b2bVatCharged === true; // true only for PL deliveries
  var STORAGE_KEY = 'b2b_vat_view';

  function mode() {
    if (!CHARGED) return 'net'; // prices are net & final — nothing to toggle
    try {
      var v = localStorage.getItem(STORAGE_KEY);
      return v === 'net' ? 'net' : 'gross'; // PL default: gross (inkl. MwSt.)
    } catch (e) { return 'gross'; }
  }

  // Sticker prices: PL = gross (VAT included) -> net view divides the VAT
  // out. Everywhere else the sticker price is already net -> factor 1.
  function factor() {
    return (CHARGED && mode() === 'net') ? 1 / (1 + RATE / 100) : 1;
  }

  // sticker cents -> displayed cents (rounded)
  window.__vatScaleC = function (cents) {
    if (cents == null || isNaN(cents)) return cents;
    return Math.round(cents * factor());
  };
  window.__vatScale = window.__vatScaleC;
  // reverse: displayed -> sticker cents
  window.__vatUnscaleC = function (cents) {
    if (cents == null || isNaN(cents)) return cents;
    return Math.round(cents / factor());
  };
  window.__vatLabel = function () {
    return mode() === 'gross' ? 'inkl. MwSt.' : 'exkl. MwSt.';
  };
  window.__vatMode = mode;

  function fmt(cents) {
    try {
      var f = window.RosentalDiscount && window.RosentalDiscount.formatMoney;
      if (f) return f(cents);
    } catch (e) {}
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00A0€';
  }

  /* --- Liquid-rendered amounts: [data-vat-cents] (attribute = sticker cents) --- */
  function applyDataCents(root) {
    (root || document).querySelectorAll('[data-vat-cents]').forEach(function (el) {
      var cents = parseInt(el.getAttribute('data-vat-cents'), 10);
      if (isNaN(cents)) return;
      var prefix = el.getAttribute('data-vat-prefix') || '';
      el.textContent = prefix + fmt(window.__vatScaleC(cents));
    });
  }

  /* --- explanatory sentence below the PDP price:
         [data-vat-reciprocal-cents] (attribute = sticker cents). --- */
  function applyReciprocal(root) {
    (root || document).querySelectorAll('[data-vat-reciprocal-cents]').forEach(function (el) {
      if (!CHARGED) {
        // Net price is the final amount — no reciprocal to show.
        el.textContent = 'Preis exkl.\u00A0MwSt.';
        return;
      }
      var grossCents = parseInt(el.getAttribute('data-vat-reciprocal-cents'), 10);
      if (isNaN(grossCents)) { el.textContent = ''; return; }
      if (mode() === 'gross') {
        el.textContent = 'Dargestellter Preis ist inkl.\u00A0MwSt.';
      } else {
        el.textContent = 'Dargestellter Preis ist exkl.\u00A0MwSt. \u2013 Preis inkl.\u00A0MwSt. betr\u00E4gt: ' + fmt(grossCents);
      }
    });
  }
  window.__vatApplyReciprocal = applyReciprocal;

  /* --- labels: "Preis exkl./inkl. MwSt." + subtotal tooltip ---
     Details live in the global VAT info drawer (#b2b-vat-info-drawer),
     opened via data-native-drawer-open on the info icons. */
  var DETAILS_NOTE = 'Tippe f\u00FCr Details zur MwSt.';

  function applyLabels() {
    var gross = mode() === 'gross';
    document.querySelectorAll('.vat-mode-label').forEach(function (el) {
      el.textContent = gross ? 'Preis inkl.\u00A0MwSt.' : 'Preis exkl.\u00A0MwSt.';
    });
    document.querySelectorAll('[data-vat-total-label]').forEach(function (el) {
      el.textContent = gross ? '(inkl. MwSt.)' : '(exkl. MwSt.)';
    });
    document.querySelectorAll('.subtotal-info-icon[data-tooltip]').forEach(function (el) {
      var text;
      if (!CHARGED) {
        text = 'Alle Preise exkl. MwSt. \u2013 f\u00FCr deine Lieferung wird keine MwSt. berechnet. ';
      } else if (gross) {
        text = 'Alle Preise inkl. MwSt. (' + RATE + ' %). ';
      } else {
        text = 'Die Zwischensumme ist immer inkl. MwSt. \u2013 mit * markierte Preise sind exkl. MwSt. ';
      }
      el.setAttribute('data-tooltip', text + DETAILS_NOTE);
    });
    // Asterisks + sticky "Preisinformation" pill only apply to the
    // informational net view in the PL model (CSS keys on vat-view--net).
    document.body.classList.toggle('vat-view--gross', CHARGED && gross);
    document.body.classList.toggle('vat-view--net', CHARGED && !gross);
  }

  /* --- toggle UIs (only rendered for PL) --- */
  function syncToggles() {
    var gross = mode() === 'gross';
    document.querySelectorAll('[data-vat-toggle-input]').forEach(function (input) {
      input.checked = gross;
    });
  }

  function setMode(next) {
    if (!CHARGED) return;
    try { localStorage.setItem(STORAGE_KEY, next); } catch (e) {}
    refresh();
    // prices-loader re-renders all price-list elements on this event
    window.dispatchEvent(new CustomEvent('cart-config:update'));
    window.dispatchEvent(new CustomEvent('vat-view:change', { detail: { mode: next } }));
  }

  function refresh() {
    applyDataCents();
    applyReciprocal();
    applyLabels();
    syncToggles();
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches('[data-vat-toggle-input]')) {
      setMode(e.target.checked ? 'gross' : 'net');
    }
  });

  // Re-apply whenever the cart drawer / sections re-render Liquid content.
  ['cart:change', 'cart:refresh', 'cart-drawer:refreshed', 'cart-config:update'].forEach(function (evt) {
    document.addEventListener(evt, function () { setTimeout(refresh, 50); });
    window.addEventListener(evt, function () { setTimeout(refresh, 50); });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
